<ng-container>
	<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
		<div fxLayout="row wrap" fxLayoutAlign="space-around" fxLayoutGap="0px grid" fxLayoutGap.lt-xl="12px grid">
			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50%">
				<mat-label><span translate>身長</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="height" matInput max="999" min="0" name="height" placeholder="" step="1" style="text-align: right;" type="number">
					<div>cm</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50">
				<mat-label><span translate>ゴルフ暦</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="experience" matInput max="999" min="0" name="experience" placeholder="" step="1" style="text-align: right;" type="number">
					<div translate>年</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50">
				<mat-label><span translate>平均スコア</span></mat-label>
				<input [(ngModel)]="score" matInput max="999" min="0" name="score" placeholder="" step="1" style="text-align: right;" type="number">
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50">
				<mat-label><span translate>ドライバーの距離</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="driver" matInput max="999" min="0" name="driver" placeholder="" step="1" style="text-align: right;" type="number">
					<div translate>Yard</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50">
				<mat-label><span translate>7番アイアンの距離</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="seveniron" matInput max="999" min="0" name="seveniron" placeholder="" step="1" style="text-align: right;" type="number">
					<div translate>Yard</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50">
				<mat-label><span translate>年間ラウンド回数</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="rounds" fxFlex="80" matInput max="999" min="0" name="rounds" placeholder="" step="1" style="text-align: right;" type="number">
					<div fxFlex translate>回/年</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50">
				<mat-label><span translate>月間練習回数</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="practice" fxFlex="80" matInput max="999" min="0" name="practice" placeholder="" step="1" style="text-align: right;" type="number">
					<div fxFlex translate>回/月</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50">
				<mat-label><span translate>オフィシャルハンディ</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="handicap" matInput max="99" min="0" name="handicap" placeholder="" step="1" style="text-align: right;" type="number">
				</div>
			</mat-form-field>
		</div>

		<div fxLayout="column" fxLayout.gt-sm="row">
			<mat-card style="margin:8px;" fxLayoutGap="8px">
				<mat-card-header>
					<mat-card-title><span translate>所属先企業選択</span></mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div fxLayout="column" fxLayout.gt-md="row">
						<mat-form-field fxFlex style="margin:30px">
							<mat-label>studio</mat-label>
							<mat-select #studio_select="ngModel" (selectionChange)="onChangeStudio()" [(ngModel)]="studio" name="studio_select" required>
								<mat-option *ngFor="let studio of studios" [value]="studio">
									{{studio.account.content.nickname}}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="studio_select.errors?.['required'];"><span translate>選択してください</span></mat-error>
						</mat-form-field>

						<mat-form-field fxFlex style="margin:15px">
							<mat-chip-list #columnList aria-label="column">
								<mat-chip (removed)="onRemoveItem(studio.account)" *ngFor="let studio of selected_studios" [removable]="true" [selectable]="true">
									{{studio.account.content.nickname}}
									<mat-icon matChipRemove>cancel</mat-icon>
								</mat-chip>
							</mat-chip-list>
						</mat-form-field>
					</div>
				</mat-card-content>
				<mat-card-actions>
					<div fxLayout="row" fxLayoutAlign="center">
						<button (click)="onAddItem(studio.account)" [disabled]="(form.invalid || isProgress || !studio.account)" style="background-color:#8e8e8e;width: 110px;" mat-raised-button>
							<div fxLayout="row" fxLayoutAlign="space-between center">
								<mat-icon fxFlex="30">add_circle</mat-icon>
								<div fxFlex="70" translate>追加</div>
							</div>
						</button>
					</div>
				</mat-card-actions>
			</mat-card>
			<belongs-panel #belongs_panel style="margin:8px;" fxLayoutGap="8px" [auth]="auth" [account]="account"></belongs-panel>
		</div>
		<div fxLayout="row" fxLayoutAlign="center">
			<button (click)="onAccept()" [disabled]="form.invalid || isProgress" mat-raised-button style="margin:20px;background-color:#99774a;width: 200px;" id="mat-update-button">
				<div fxLayout="row" fxLayoutAlign="space-between center">
					<mat-icon fxFlex="10">done_outline</mat-icon>
					<div fxFlex="80" translate>更新</div>
					<div fxFlex="10"></div>
				</div>
			</button>
		</div>
	</form>
</ng-container>
